import { Compass } from 'lucide-react';
import type { ReactNode } from 'react';

/** Centered card used by the sign-in, setup and invite screens. */
export function AuthLayout({ title, description, children }: { title: string; description?: string; children: ReactNode }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-[var(--radius-control)] bg-primary text-primary-foreground">
            <Compass className="h-4 w-4" aria-hidden="true" />
          </span>
          <span className="text-base font-semibold tracking-tight text-foreground">Atlas</span>
        </div>
        <div className="rounded-[var(--radius-panel)] border border-border bg-surface p-5">
          <h1 className="text-lg font-semibold text-foreground">{title}</h1>
          {description ? <p className="mt-1 text-[13px] text-muted-foreground">{description}</p> : null}
          <div className="mt-5">{children}</div>
        </div>
      </div>
    </div>
  );
}
